import AboutYourPayment from './AboutYourPayment';

export default AboutYourPayment;
